<template>
  <AppSection id="scope-dashboard" :title="$t($getConst.pages.scopeSettingDashboard.scope) + ' ' + scope_name" type="page">
    <router-view></router-view>
  </AppSection>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import {getOneScope} from "../../../api/scopes.api";
  export default {
    name: "index",
    components: {AppSection},
    props: {
      scope_id: null,
      scope_name: null
    }
  }
</script>

<style scoped>

</style>
